export const BRAND_LOGO_FALLBACK_TOKEN = 'pk_fw3EgsMdRnKqF-72FUrrmQ';

interface BrandLike {
  logo?: string | null;
  cover_image?: string | null;
  name?: string | null;
}

export function logoDevUrl(name?: string | null): string {
  const domain = (name || '').replace(/\s+/g, '');
  if (!domain) return '';
  return `https://img.logo.dev/${domain}.com?token=${BRAND_LOGO_FALLBACK_TOKEN}`;
}

export function brandLogoSources(brand?: BrandLike | null): string[] {
  const stored = (brand?.logo || brand?.cover_image || '').trim();
  return [stored, logoDevUrl(brand?.name)].filter(Boolean);
}

export function getBrandLogoUrl(brand?: BrandLike | null): string {
  return brandLogoSources(brand)[0] || '';
}
